import { render } from "./CompanyForm.vue?vue&type=template&id=1e06a090&scoped=true&ts=true"
import script from "./CompanyForm.vue?vue&type=script&lang=ts"
export * from "./CompanyForm.vue?vue&type=script&lang=ts"

import "./CompanyForm.vue?vue&type=style&index=0&id=1e06a090&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e06a090"]])

export default __exports__